/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaSnapshot model module.
 * @module model/AqaSnapshot
 * @version v0
 */
export default class AqaSnapshot {
  /**
   * Constructs a new <code>AqaSnapshot</code>.
   * @alias module:model/AqaSnapshot
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaSnapshot</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaSnapshot} obj Optional instance to populate.
   * @return {module:model/AqaSnapshot} The populated <code>AqaSnapshot</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaSnapshot();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('umbrellaIds'))
        obj.umbrellaIds = ApiClient.convertToType(data['umbrellaIds'], ['String']);
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Number');
      if (data.hasOwnProperty('createdBy'))
        obj.createdBy = ApiClient.convertToType(data['createdBy'], 'String');
      if (data.hasOwnProperty('filesize'))
        obj.filesize = ApiClient.convertToType(data['filesize'], 'Number');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('originalFilename'))
        obj.originalFilename = ApiClient.convertToType(data['originalFilename'], 'String');
      if (data.hasOwnProperty('label'))
        obj.label = ApiClient.convertToType(data['label'], 'String');
      if (data.hasOwnProperty('dataFilepath'))
        obj.dataFilepath = ApiClient.convertToType(data['dataFilepath'], 'String');
      if (data.hasOwnProperty('charsetName'))
        obj.charsetName = ApiClient.convertToType(data['charsetName'], 'String');
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('statusChangedBy'))
        obj.statusChangedBy = ApiClient.convertToType(data['statusChangedBy'], 'String');
      if (data.hasOwnProperty('statusChangedById'))
        obj.statusChangedById = ApiClient.convertToType(data['statusChangedById'], 'String');
      if (data.hasOwnProperty('statusChangedDate'))
        obj.statusChangedDate = ApiClient.convertToType(data['statusChangedDate'], 'Number');
      if (data.hasOwnProperty('sheetIndex'))
        obj.sheetIndex = ApiClient.convertToType(data['sheetIndex'], 'Number');
      if (data.hasOwnProperty('sheetName'))
        obj.sheetName = ApiClient.convertToType(data['sheetName'], 'String');
      if (data.hasOwnProperty('sheetChosen'))
        obj.sheetChosen = ApiClient.convertToType(data['sheetChosen'], 'Boolean');
      if (data.hasOwnProperty('openForStatusChanges'))
        obj.openForStatusChanges = ApiClient.convertToType(data['openForStatusChanges'], 'Boolean');
      if (data.hasOwnProperty('reviewStatus'))
        obj.reviewStatus = ApiClient.convertToType(data['reviewStatus'], 'String');
      if (data.hasOwnProperty('successfulInsertions'))
        obj.successfulInsertions = ApiClient.convertToType(data['successfulInsertions'], 'Number');
      if (data.hasOwnProperty('failedInsertions'))
        obj.failedInsertions = ApiClient.convertToType(data['failedInsertions'], 'Number');
      if (data.hasOwnProperty('version'))
        obj.version = ApiClient.convertToType(data['version'], 'String');
      if (data.hasOwnProperty('creadtedById'))
        obj.creadtedById = ApiClient.convertToType(data['creadtedById'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaSnapshot.prototype.id = undefined;

/**
 * @member {Array.<String>} umbrellaIds
 */
AqaSnapshot.prototype.umbrellaIds = undefined;

/**
 * @member {Number} dateCreated
 */
AqaSnapshot.prototype.dateCreated = undefined;

/**
 * @member {String} createdBy
 */
AqaSnapshot.prototype.createdBy = undefined;

/**
 * @member {Number} filesize
 */
AqaSnapshot.prototype.filesize = undefined;

/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
AqaSnapshot.TypeEnum = {
  /**
   * value: "excel"
   * @const
   */
  excel: "excel",

  /**
   * value: "csv"
   * @const
   */
  csv: "csv",

  /**
   * value: "tsv"
   * @const
   */
  tsv: "tsv",

  /**
   * value: "piecemeal"
   * @const
   */
  piecemeal: "piecemeal"
};
/**
 * @member {module:model/AqaSnapshot.TypeEnum} type
 */
AqaSnapshot.prototype.type = undefined;

/**
 * @member {String} originalFilename
 */
AqaSnapshot.prototype.originalFilename = undefined;

/**
 * @member {String} label
 */
AqaSnapshot.prototype.label = undefined;

/**
 * @member {String} dataFilepath
 */
AqaSnapshot.prototype.dataFilepath = undefined;

/**
 * @member {String} charsetName
 */
AqaSnapshot.prototype.charsetName = undefined;

/**
 * @member {String} status
 */
AqaSnapshot.prototype.status = undefined;

/**
 * @member {String} statusChangedBy
 */
AqaSnapshot.prototype.statusChangedBy = undefined;

/**
 * @member {String} statusChangedById
 */
AqaSnapshot.prototype.statusChangedById = undefined;

/**
 * @member {Number} statusChangedDate
 */
AqaSnapshot.prototype.statusChangedDate = undefined;

/**
 * @member {Number} sheetIndex
 */
AqaSnapshot.prototype.sheetIndex = undefined;

/**
 * @member {String} sheetName
 */
AqaSnapshot.prototype.sheetName = undefined;

/**
 * @member {Boolean} sheetChosen
 */
AqaSnapshot.prototype.sheetChosen = undefined;

/**
 * @member {Boolean} openForStatusChanges
 */
AqaSnapshot.prototype.openForStatusChanges = undefined;

/**
 * Allowed values for the <code>reviewStatus</code> property.
 * @enum {String}
 * @readonly
 */
AqaSnapshot.ReviewStatusEnum = {
  /**
   * value: "UNSET"
   * @const
   */
  UNSET: "UNSET",

  /**
   * value: "OPEN"
   * @const
   */
  OPEN: "OPEN",

  /**
   * value: "BUSY"
   * @const
   */
  BUSY: "BUSY",

  /**
   * value: "CLOSED"
   * @const
   */
  CLOSED: "CLOSED"
};
/**
 * @member {module:model/AqaSnapshot.ReviewStatusEnum} reviewStatus
 */
AqaSnapshot.prototype.reviewStatus = undefined;

/**
 * @member {Number} successfulInsertions
 */
AqaSnapshot.prototype.successfulInsertions = undefined;

/**
 * @member {Number} failedInsertions
 */
AqaSnapshot.prototype.failedInsertions = undefined;

/**
 * @member {String} version
 */
AqaSnapshot.prototype.version = undefined;

/**
 * @member {String} creadtedById
 */
AqaSnapshot.prototype.creadtedById = undefined;

